const API_URL = process.env.REACT_APP_CARDS;

export async function deleteNode(authFetch, nodeId) {
  return await authFetch(`${API_URL}${nodeId}/`, {
    method: 'DELETE',
  });
}
